import {KeyValidation} from "../../api/VisitWithStatStore";
import {KeyData, KeyLocation} from "../../api/Model";
import React, {useCallback, useMemo} from "react";
import {VisitStatBlock} from "../../components/visit-stat-block/VisitStatBlock";
import {List, ListItem, ListItemText, Stack} from "@mui/material";
import {KeyLocationShield} from "../../components/location/KeyLocationShield";
import {TooltipKeyLink} from "./TooltipKeyLink";
import {numberCmp} from "../../util/SortUtil";

export function NotReportedKeysStatBlock({validation}: {
    validation: KeyValidation,
}) {
    function locationOrder(locationType: KeyLocation['type']): number {
        switch (locationType) {
            case "with-employee":
                return 0;
            case "with-guest":
                return 1;
            case "with-vault":
                return 2;
            case "lost":
                return 3;
            case "damaged":
                return 4;
            case "deactivated":
                return 5;
        }
    }

    const keyOrder = useCallback((key: KeyData): number => {
        return key.history.map(record => locationOrder(record.location.type)).reduce((a, b) => Math.min(a, b), locationOrder('deactivated'));
    }, []);

    const missingKeys = useMemo(() => {
        return validation.missingFromReportKeys
            .sort(numberCmp(it => keyOrder(it)));
    }, [validation.missingFromReportKeys, keyOrder]);

    return (
        <VisitStatBlock
            color={missingKeys.length > 0 ? keyOrder(missingKeys[0]) <= locationOrder('with-vault') ? 'error' : 'warning' : 'inherit'}
            tooltip={
                <List>
                    <ListItem>
                        <ListItemText
                            primary="Not Reported Keys"
                            secondary="Registered keys not mentioned in the report"
                            slotProps={{
                                secondary: {color: 'grey.400'}
                            }}
                        />
                    </ListItem>
                    {missingKeys.map(key => (
                        <ListItem key={key.keyNumber}>
                            <Stack direction="row" alignItems="center" gap={3} width="100%">
                                <TooltipKeyLink keyNumber={key.keyNumber}/>
                                <Stack direction="row" gap={2}>{key.history.map(record => (
                                    <KeyLocationShield key={record.id} location={record.location} tooltip/>
                                ))}</Stack>
                            </Stack>
                        </ListItem>
                    ))}
                </List>
            }
            tooltipWidth={400}
        >
            Not reported: {validation.missingFromReportKeys.length}
        </VisitStatBlock>
    );
}
